module.exports = __webpack_public_path__ + "img/event_seat.007d7045.svg";